import { ReportDataDto } from "../interfaces/report";
import * as XLSX from "xlsx";

export const convertImageSourceToFile = (url: string, fileName?: string) => {
  return fetch(url).then(async (response) => {
    const contentType = response.headers.get("content-type");

    const blob = await response.blob();
    const file = new File([blob], fileName || Date.now().toString(), {
      type: contentType as string,
    });

    return file;
  });
};

export const convertReportDataToFile = (
  reportData: ReportDataDto,
  reportName?: string
): File => {
  const workbook = XLSX.utils.book_new();

  for (const sheetName in reportData) {
    const worksheet = XLSX.utils.aoa_to_sheet(reportData[sheetName].data);

    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  }

  return new File(
    [new Blob([XLSX.write(workbook, { bookType: "xlsx", type: "buffer" })])],
    `${reportName || "generated_report"}.xlsx`
  );
};

export const downloadFile = (file: File): void => {
  var a = document.createElement("a");
  a.href = window.URL.createObjectURL(file);
  a.download = file.name;
  a.click();
};
